import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as fsFunction from '../function'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: fsFunction.RESOURCE.payload.dimension.partialId,
      partialId: fsFunction.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Determines whether the Function is an Expense or Revenue Function.',
    isOptional: true,
    name: 'FS Function Type',
    partialId: PartialId.Standard.create('fs_func_type'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
